import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/api'
import helpers from './helpers'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);
require('./assets/scss/style.scss')
Vue.config.productionTip = false
Vue.mixin(helpers)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
